import React, { useEffect } from "react";
import SectionTitle from "../common/SectionTitle";
import DynamicImage from "../common/DynamicImage";
import { getBackgroundClass, getLayoutClass } from "../../utils/sectionHelpers";
import { HighlightText } from "../common/HighlightText";

const HowItWorks = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  const layoutClass = getLayoutClass(settings.layout);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const dateDiv = entry.target.querySelector(".timeline-date");
          const title = entry.target.querySelector(".timeline-title");
          const image = entry.target.querySelector(".image");

          if (entry.isIntersecting) {
            dateDiv?.classList.add("active");
            title?.classList.add("active");
            image?.classList.add("active");
          } else {
            dateDiv?.classList.remove("active");
            title?.classList.remove("active");
            image?.classList.remove("active");
          }
        });
      },
      { threshold: 0.2, rootMargin: "-40% 0px -40% 0px" },
    );

    const blocks = document.querySelectorAll(
      ".how-it-works-timeline .timeline-block",
    );
    blocks.forEach((block) => observer.observe(block));

    return () => {
      blocks.forEach((block) => observer.unobserve(block));
    };
  }, []);

  return (
    <div
      className={`history-area ptb-70 how-its-work-section ${backgroundClass}`}
    >
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <SectionTitle data={data} />
          </div>
        </div>

        {/* Timeline */}
        <ol className="timeline history-timeline history-timeline-style-two how-it-works-timeline">
          {data?.strategyContents?.map((item, index) => {
            const cardSettings = item?.Settings || {};
            const cardBgClass = getBackgroundClass(cardSettings.background);

            return (
              <li className="timeline-block" key={index}>
                <div className={`timeline-content ${cardBgClass}`}>
                  <div
                    className={`row align-items-center gx-lg-5 gy-4 ${layoutClass}`}
                  >
                    <div className="col-lg-5 col-md-12">
                      <div className="image">
                        <DynamicImage image={item.image} alt={item.title} />
                      </div>
                    </div>

                    <div className="col-lg-7 col-md-12">
                      <div className="content">
                        <h3 className="timeline-title">{item.title}</h3>

                        {/* Dynamic Rich Text Rendering */}
                        {item?.description?.map((block, index) => {
                          switch (block.type) {
                            case "paragraph":
                              return (
                                <p key={index}>
                                  {block.children.map((c) => c.text).join("")}
                                </p>
                              );

                            case "heading":
                              const Tag = `h${block.level}`;
                              return (
                                <Tag key={index} className="mt-4 mb-3">
                                  <HighlightText content={block.children.map((c) => c.text).join("")} />
                                </Tag>
                              );

                            case "list":
                              return (
                                <div key={index} className="overview-content">
                                  <div className="content">
                                    {block.children.map((item, i) => (
                                      <div key={i} className="features-text">
                                        <h4>
                                          <i className="flaticon-tick"></i>{" "}
                                          {item.children
                                            .map((c) => c.text)
                                            .join("")}
                                        </h4>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              );

                            default:
                              return null;
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
};

export default HowItWorks;
